import { render, staticRenderFns } from "./BatteryCapacityForm.vue?vue&type=template&id=70a96675"
import script from "./BatteryCapacityForm.vue?vue&type=script&lang=ts"
export * from "./BatteryCapacityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports